import React from "react";
import { RemoveScroll } from "react-remove-scroll";
import ReactDom from "react-dom";
import { RiCloseCircleLine } from "react-icons/ri";

const UploadDocumentModal = ({
    open,
    values,
    handleClose,
    fileInputRef,
    setFieldValue,
    activeProofField,
}) => {
    if (!open) return null;

    const currentFile = values?.[activeProofField];

    const handleClear = () => {
        setFieldValue(activeProofField, null);
    };

    const handleBrowseClick = () => {
        document.getElementById("fileInput").click();
    };

    return ReactDom.createPortal(
        <div className='fixed top-0 left-0 right-0 h-screen bg-black/40 overflow-clip z-50'>
            <RemoveScroll className='flex justify-center h-full flex-col p-10'>
                <div className='relative flex flex-col gap-5 justify-center items-center bg-white pt-20 pb-10 px-20 rounded-md max-w-[800px] mx-auto w-full place-self-center'>
                    <button
                        onClick={handleClose}
                        className='place-self-end p-2 absolute top-10 inset-x-10'
                    >
                        <RiCloseCircleLine className='text-black/90 hover:text-black text-2xl' />
                    </button>

                    {!currentFile ? (
                        <div
                            className='border-2 border-dashed border-blue-400 rounded-lg py-10 min-h-[200px] flex flex-col justify-center text-center cursor-pointer hover:bg-blue-50 w-full'
                            onClick={handleBrowseClick}
                        >
                            <div className='text-blue-600 text-lg font-medium max-w-[500px] mx-auto'>
                                Browse file to upload
                            </div>
                            <input
                                id='fileInput'
                                type='file'
                                className='hidden'
                                accept='.pdf,.png,.jpg,.jpeg'
                                onClick={(e) => (e.target.value = null)}
                                onChange={(e) =>
                                    setFieldValue(activeProofField, e.target.files[0])
                                }
                                name={activeProofField}
                                ref={fileInputRef}
                            />
                        </div>
                    ) : (
                        <div className='flex gap-2 items-center w-full justify-between text-MetallicBlue mt-5'>
                            <p>
                                File upload: <span>{currentFile?.name}</span>
                            </p>
                            <div className="flex gap-4">
                                <button
                                    onClick={handleClear}
                                    className='bg-[red]/70 px-6 py-1.5 rounded-md shadow-md text-white hover:bg-[red]/90'
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    )}
                    <button
                        onClick={handleClose}
                        className='text-MetallicBlue rounded-md px-8 py-1 border-MetallicBlue/90 hover:border-MetallicBlue bg-white/90 hover:bg-white shadow-md border-2'
                    >
                        Confirm
                    </button>
                </div>
            </RemoveScroll>
        </div>,
        document.getElementById("portal")
    );
};

export default UploadDocumentModal;
